import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Div, Main, Footer } from 'glamorous';

import { theme } from '../components/theme';

const TemplateWrapper = ({ children, data }) => (
  <Div
    css={{
      width: '100vw',
      height: '100vh',
    }}
  >
    <Helmet>
      <title>
        {`${data.site.siteMetadata.title} - ${data.site.siteMetadata.subtitle}`}
      </title>
      <meta name="description" content={data.site.siteMetadata.subtitle} />
      <style type="text/css">{`
        html, body {
          background-color: ${theme.brandBlack}
        }
      `}</style>
    </Helmet>

    <Main
      css={{
        minHeight: `calc(100vh - ${theme.footerHeight})`,
      }}
    >
      {children()}
    </Main>
    <Footer
      css={{
        boxSizing: 'border-box',
        height: theme.footerHeight,
        padding: theme.gutter,
        fontSize: '0.75rem',
        textAlign: 'center',
      }}
    >
      <div>▬▬▬ι═══════════ﺤ</div>
      <div>&copy; {new Date().getFullYear()} Red Ronin</div>
    </Footer>
  </Div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        title
        subtitle
      }
    }
  }
`;

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js